export enum OrdersTab {
  Active = 'active',
  ManualQueue = 'manual-queue',
  ManualBatches = 'manual-batches',
  Completed = 'completed',
  HoldCompleted = 'hold-completed',
  Cancelled = 'cancelled',
  Dispute = 'dispute',
  TraderDisputeArchive = 'trader-dispute-archive',
  DisputeArchive = 'dispute-archive',
  RequisitesVerification = 'requisites-verification',
  TraderDispute = 'trader-dispute',
  ProviderDispute = 'provider-dispute',
  All = 'all',
}
